exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vuetify-aggregator-card{margin-bottom:20px}", "", {"version":3,"sources":["/var/www/localhost/public_html/app/vues/src/layouts/vuetify-aggregator-card.vue"],"names":[],"mappings":"AACA,yBACE,kBAAoB,CACrB","file":"vuetify-aggregator-card.vue","sourcesContent":["\n.vuetify-aggregator-card {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-275a59b2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/vuetify-aggregator-card.vue
// module id = 657
// module chunks = 0 1 2 3